<template>
    <v-container fill-height class="d-flex align-center justify-center">
        <v-row justify="center" align="center" class="w-100">
            <!-- <v-col cols="12" class="text-center">
                <img src="@/assets/logo_sondeos.png">
            </v-col> -->
            <home-card
                v-if="this.me.role.permissions.includes('PRODUCTO_SHOW')"
                :title="'Gestión de Stock'"
                :subtitle="$t('base.subtitleCardStock')"
                :img="require('@/assets/cards/project-management.png')"
                :link="'producto-management'"
            ></home-card>
            <home-card
                v-if="this.me.role.permissions.includes('MOVIMIENTO_SHOW')"
                :title="'Ventas'"
                :subtitle="$t('base.subtitleCardVentas')"
                :img="require('@/assets/cards/ventas-management.png')"
                :link="'movimiento-management'"
            ></home-card>
            <home-card
                v-if="this.me.role.permissions.includes('DASHBOARD_SHOW')"
                :title="'Dashboards'"
                :subtitle="$t('base.subtitleDashboards')"
                :img="require('@/assets/cards/dashboard-management.png')"
                :link="'dashboard-management'"
            ></home-card>
            <home-card
                v-if="this.me.role.permissions.includes('CONFIGURACION_SHOW')"
                :title="$t('userConfiguration.title')"
                :subtitle="$t('userConfiguration.subtitle')"
                :img="require('@/assets/cards/configuracion-management.png')"
                :link="'user-configuration-management'"
            ></home-card>
        </v-row>
    </v-container>
</template>

<script>
    import HomeCard from './HomeCard'
    import {mapGetters} from "vuex";
    export default {
        name: 'HomePage',
        components: {
            HomeCard
        },
        computed: {
            ...mapGetters(['me']),
            getUserId() {
                return this.me ? this.me.id : null
            }
        }
    }
</script>